import { FilterOption as FilterOptionDrawer } from 'src/models/Filter';

// contast
import { currentUser } from 'src/models/Filter/filterData';

const metricFilterCurrentUserToDrawerFilterCurrentUser = (
  onAddFilterDrawer: (filterOptionDrawer: FilterOptionDrawer) => void,
  isChecked: boolean,
  userID: string,
): void => {
  if (!isChecked) {
    return;
  }
  onAddFilterDrawer(currentUser(userID));
};

export default metricFilterCurrentUserToDrawerFilterCurrentUser;
